import { Grid, Typography } from "@mui/material";
import { Button, required, SelectInput, useNotify, useRefresh } from "react-admin";
import { AcademicRequestStatus } from "utils/choices";
import { studentRequests } from "api/studentApi";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const ChangeStatusDialog = ({ record }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async data => {
    await dataProvider.customRequest(
      studentRequests.updateAcademicRequestStatus(record?.id),
      { toStatus: data.toStatus },
      "PUT",
    );
    notify("Успешно заявена промяна на статус", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Смяна на статус"
      onConfirm={handleSubmit}
      defaultValues={{ toStatus: record?.status }}
      triggerButton={
        <Button
          startIcon={<AutorenewIcon />}
          size="small"
          label="Статус"
        />
      }
    >
      <Typography sx={{ mb: 2 }}>
        Текущ статус: <strong>{AcademicRequestStatus.find(s => s.id === record.status)?.name ?? record.status}</strong>
      </Typography>
      <Grid
        container
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <SelectInput
          emptyText={false}
          validate={required()}
          label="Избери статус"
          source="toStatus"
          choices={AcademicRequestStatus}
        />
      </Grid>
    </FormModal>
  );
};

export default ChangeStatusDialog;
